<template lang="pug">
div.todayTopic
  SectionTitle(
    :sectionText="title"
    :displayCardCounter="false"
    :displaySeeMoreText="false"
  )
  .article-list
    RelatedGovAnnounces(v-for='(info, idx) in infos'
      :key='idx'
      :idx='idx + 1'
      :info='info'
      :staticData='staticData'
      :token='token'
    )
</template>

<script>
import RelatedGovAnnounces from '@/components/latest_articles/related_gov_announces.vue';
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import { getRouteByParam } from '@/plugins/tool.js';

export default {
  props: {
    title: String,
    type: String,
    categoryId: Number,
    params: Object,
    staticData: Object
  },
  components: {
    RelatedGovAnnounces,
    SectionTitle
  },
  data() {
    return {
      infos: [],
      typeDict: {},
      query: {},
      token: localStorage.getItem(this.$store.state.storageKeys.token)
    };
  },
  async created() {
    this.typeDict.govAnnounces = this.$store.state.routes.govAnnounces;
    await this.getInfo();
  },
  methods: {
    async getInfo() {
      let route =
        this.$store.state.URLs.api +
        '/' +
        this.$store.state.lang +
        this.typeDict[this.type];
      // this.params.govOptionId from gov_announce_single.vue query parameter
      this.query.govOptionId = this.params.govOptionId;
      route = getRouteByParam(this.query, route);
      let result = await this.$axios.get(route);
      this.infos = result.data.content;
      this.infos.forEach((info, index, object) => {
        if (info.id == this.params.id) {
          object.splice(index, 1);
        }
      });
      this.infos = this.infos.slice(0, 5);
    }
  }
};
</script>
